var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertStandby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_alert_standby",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24754",
    "data-name": "\\uC0AC\\uAC01\\uD615 24754",
    width: 16,
    height: 16,
    transform: "translate(-3 -4)",
    fill: "#43c0a4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 24,
    height: 24,
    fill: "#43c0a4",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_133",
    "data-name": "\\uADF8\\uB8F9 133",
    transform: "translate(10.5 7.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_134",
    "data-name": "\\uADF8\\uB8F9 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_136",
    "data-name": "\\uADF8\\uB8F9 136",
    transform: "translate(-2.5 1.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_26199",
    "data-name": "\\uADF8\\uB8F9 26199",
    transform: "translate(-1 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_26559",
    "data-name": "\\uADF8\\uB8F9 26559",
    transform: "translate(-59.186 -548.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_26557",
    "data-name": "\\uADF8\\uB8F9 26557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10759",
    "data-name": "\\uD328\\uC2A4 10759",
    d: "M64.415,559.7a7.229,7.229,0,1,1,7.23-7.228A7.236,7.236,0,0,1,64.415,559.7Zm0-13.258a6.03,6.03,0,1,0,6.029,6.03A6.036,6.036,0,0,0,64.415,546.438Z",
    fill: "#2992ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_26558",
    "data-name": "\\uADF8\\uB8F9 26558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10760",
    "data-name": "\\uD328\\uC2A4 10760",
    d: "M67.315,553.9h-2.9a.6.6,0,0,1-.6-.6v-3.315a.6.6,0,0,1,1.2,0V552.7h2.3a.6.6,0,1,1,0,1.2Z",
    fill: "#2992ff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertStandby);
export default __webpack_public_path__ + "static/media/icon_alert_standby.aaa85ec2c177975d1571915f41ec8e59.svg";
export { ForwardRef as ReactComponent };